import AlpineComponentMagicMethod from './components'
import AlpineToggleMagicMethod from './toggle'

export default {
    AlpineComponentMagicMethod,
    AlpineToggleMagicMethod,
}
